<template>
  <svg :width="width" :height="height" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M3.33366 2.66699H15.3337V10.667H3.33366V2.66699ZM9.33366 4.66699C9.86409 4.66699 10.3728 4.87771 10.7479 5.25278C11.1229 5.62785 11.3337 6.13656 11.3337 6.66699C11.3337 7.19742 11.1229 7.70613 10.7479 8.08121C10.3728 8.45628 9.86409 8.66699 9.33366 8.66699C8.80323 8.66699 8.29452 8.45628 7.91944 8.08121C7.54437 7.70613 7.33366 7.19742 7.33366 6.66699C7.33366 6.13656 7.54437 5.62785 7.91944 5.25278C8.29452 4.87771 8.80323 4.66699 9.33366 4.66699ZM6.00033 4.00033C6.00033 4.35395 5.85985 4.69309 5.6098 4.94313C5.35975 5.19318 5.02061 5.33366 4.66699 5.33366V8.00033C5.02061 8.00033 5.35975 8.1408 5.6098 8.39085C5.85985 8.6409 6.00033 8.98004 6.00033 9.33366H12.667C12.667 8.98004 12.8075 8.6409 13.0575 8.39085C13.3076 8.1408 13.6467 8.00033 14.0003 8.00033V5.33366C13.6467 5.33366 13.3076 5.19318 13.0575 4.94313C12.8075 4.69309 12.667 4.35395 12.667 4.00033H6.00033ZM0.666992 5.33366H2.00033V12.0003H12.667V13.3337H0.666992V5.33366Z"
        :fill="iconColor"/>

  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "iconCash",
    },
    width: {
      type: [Number, String],
      default: 18,
    },
    height: {
      type: [Number, String],
      default: 18,
    },
    iconColor: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
